module.exports = __webpack_public_path__ + "static/media/shape1_5.00eb78e5.obj";